<template>
    <div class="page-home">
        <el-row>
            <el-col :span="12" :offset="6" class="top-title">
                <div :class="['status-name', status == 2 || status == 1 ? 'status-true' : 'status-false']">
                    {{status_name}}
                </div>
                <div>
                    <el-row class="active-top">
                        <el-col :span="12">
                            <div class="active-jianjie" @click="showjianjie">
                                活动简介
                            </div>
                        </el-col>
                        <el-col :span="12" style="display: flex; justify-content: flex-end;">
                            <div class="active-jiangli" @click="showjiangli" >
                                活动奖励
                            </div>
                        </el-col>

                        <el-col :span="24">
                            <el-row class="user-box">
                                <el-col :span="4">
                                    <div  class="user-avatar-box">
                                        <img class="user-avatar" :src="source_prefix + user_data.avatar" style="width:100%;" alt="">
                                    </div>
                                </el-col>
                                <el-col :span="16">
                                    <div class="user-content">
                                    <div class="user-name">{{user_data.nick_name}}</div>
                                    <div class="user-id">ID:{{user_data.number}}</div>
                                    <div class="user-school">{{user_data.school_name}}</div>
                                </div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="user-like"></div>
                                </el-col>
                                <el-col :span="24" v-if="status == 2 && has_tested" class="table-box">

                                    <template>
                                        <el-table
                                            :data="tableData"
                                            :header-cell-style="{'background-color': '#1796EF','color': '#ffffff'}"
                                            border
                                            style="width: 100%">
                                            <el-table-column
                                                label="得分"
                                                align="center"
                                                class="table-heard"
                                                >
                                                <template slot-scope="scope">
                                                    {{scope.row.score}} 分
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                align="center"
                                                class="table-heard"
                                                label="用时">
                                                <template slot-scope="scope">
                                                    {{scope.row.use_time}} S
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                fixed="right"
                                                label="操作"
                                                align="center"
                                                class="table-heard"
                                                >
                                                <template slot-scope="scope">
                                                    <el-button type="text" size="small" @click="showReport">查看报告</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        </template>
        
                                </el-col>
                                <el-col :span="24">
                                    <div style="width: 100%; text-align:center; margin-top:20px ;">
                                        <el-button type="danger" plain @click="answerQuestion" style="width:50%" round>{{activeText}}</el-button>
                                    </div>
                                </el-col>
                            </el-row>
                
                        </el-col>
                    </el-row>

                </div>
            </el-col>
        </el-row>

        <el-dialog
            title="活动简介"
            :visible.sync="dialogjianjie"
            width="60%"
            :before-close="handleClose">
            <div v-html="activeData.rule" style="width:100%"></div>
        </el-dialog>
        <el-dialog
            title="活动奖励"
            :visible.sync="dialogjiangli"
            width="60%"
            :before-close="handleClose">
            <div v-html="activeData.reward" style="width:100%"></div>
        </el-dialog>

    </div>


</template>

<script>
    import { getUserAbilityActivityInfo} from '@/api'
    import store from '@/store'
    import Waterfall from '@/components/waterfall'

    export default {
        name: 'Examination',
        components: {
            Waterfall
        },
        props: ['cate', 'words'],
        data() {
            return {
                source_prefix:process.env.VUE_APP_UPYUN_PATH,
                dialogjianjie:false,
                dialogjiangli:false,
                activeData:{},
                listForm:{
                        'page':1,
                        'limit':99,
                        'where':{}
                },
                form:{
      
                },
                signFlag:false,
                status:1,
                status_name:"",
                activeText:"活动未开始",
                currentTimeStamp:0,
                has_tested:false,
                user_data :{
                    avatar:"default/default/8e4746627bf011ebb249d07e3573eb6e.png"
                },
                intervalId:0,
                tableData:[]
                
            }
         
        },
        computed: {
        },
        methods: {
            showReport(){
                // if(this.status != 10){
                //     this.$notify.error({
                //         title: '信息提示',
                //         message: '活动结束后才可以查看报告',
                //         duration: 3000
                //     })
                //     return
                // }
        
                this.$router.push({path:'/viewreport',query: {work_guid:this.activeData.source_guid}})
            },
            handleClose()
            {
                this.dialogjianjie = false
                this.dialogjiangli = false
            },
            showjianjie()
            {
                this.dialogjianjie = true
            },
            showjiangli()
            {
                this.dialogjiangli = true
            },
            dataList(clearFlag)
            {
                var param = {
                    active_guid:this.activeData.active_guid
                }
                getUserAbilityActivityInfo(param).then(response => {
                    this.has_tested = response.has_tested
                    this.user_data = response.user_data
                    var row = {
                        score:this.user_data.score,
                        use_time:this.user_data.use_time,
                        report:""
                    }
                    this.tableData.push(row)
                })
            },
            convertToTimestamp(dateString) {
                // 将日期字符串转换为Date对象
                var date = new Date(Date.parse(dateString));
            
                // 如果日期无效，Date.parse将返回NaN
                if (isNaN(date.getTime())) {
                    // 如果日期格式不正确，可以尝试其他方法来解析日期
                    // 例如，使用正则表达式等
                    throw new Error('Invalid date format');
                }
            
                // 获取时间戳（单位：毫秒）
                var timestamp = date.getTime();
                return timestamp;
            },

             convertTimestamp(timestamp) {
                const seconds = Math.floor(timestamp / 1000);
                const days = Math.floor(seconds / (3600 * 24));
                const hours = Math.floor((seconds % (3600 * 24)) / 3600);
                const minutes = Math.floor((seconds % 3600) / 60);
                const remainingSeconds = seconds % 60;
            
                return {
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: remainingSeconds
                };
            },

            answerQuestion(){

                if(this.status == 2 && this.has_tested == false)
                {
                    this.$router.push({path:'/active/answer',query: {work_guid:this.activeData.active_guid}})
                }

                if(this.has_tested == true)
                {
                    if(this.status != 10){
                        this.$notify.error({
                            title: '信息提示',
                            message: '活动结束后才可以查看排行',
                            duration: 3000
                        })
                        return
                    }
                    this.$router.push({path:'/active/rank'})
                }
             
            },
            timeCheck(){
                var currentTimeStamp = this.currentTimeStamp
                // 当前时间戳
                
                var startTimeStamp = this.convertToTimestamp(this.activeData.start_time)
                var endTimeStamp = this.convertToTimestamp(this.activeData.end_time)

                if(currentTimeStamp < startTimeStamp){
                    this.status = 1
                    var a = startTimeStamp - currentTimeStamp
                    var convertedTime = this.convertTimestamp(a)

                    this.activeText ="活动未开始"
                    this.status_name = "距离比赛开始还有" + convertedTime.days + "天" +  convertedTime.hours  + "小时" + convertedTime.minutes  + "分" + convertedTime.seconds  + "秒"
                }
                else if(startTimeStamp < currentTimeStamp && currentTimeStamp < endTimeStamp){
                    this.status = 2

                    this.activeText ="查看排行"
                    if(this.has_tested == false ){
                        this.activeText ="开始比赛"
                    }
                    
                    this.status_name = "活动进行中"
                }
                else if(endTimeStamp > currentTimeStamp){
                    this.status = 10
                    this.activeText ="活动已结束"
                    this.status_name = "活动已结束"

                }
                this.currentTimeStamp = this.currentTimeStamp + 1000
            }
        },

        created(){
            var that = this
            
            store.dispatch('common/loadActiveData');
            this.activeData = store.state.common.activeData
            this.dataList()

            var currentTimeStamp = new Date().getTime();
         
            this.currentTimeStamp = currentTimeStamp


            this.intervalId = setInterval(() => {
                that.timeCheck()
            }, 1000); // 每1000毫秒执行一次


        },
        beforeUnmount() {
        
        },
        beforeDestroy() {
            
        },
        mounted() {
          
   
           



        }
    }
</script>
<style scoped lang="less">

    .page-home{
        min-height:80vh;
        background: #F2F6FC;
    }

    .status-name{
        height:30px;
        line-height: 30px;
    }

    .status-true{
        color:#FD413A;
    }
    .status-false{
        color:#999999;
    }

    .active-top{
        margin-top:50px;
    }

    .active-jianjie{
        width: 90%;
 
        color: #1796EF;
        background-color: #fff;
        padding:30px 0;
        cursor: pointer;
    }

    .active-jiangli{
        width: 90%;
 
        color: #1796EF;
        background-color: #fff;
        padding:30px 0;
        cursor: pointer;
    }

    .user-box{
        margin-top: 20px;
        background: #fff;
        padding: 30px 40px;

    }
    .user-avatar-box{
        width: 80%;
    }
    .user-avatar{
        border: 1px #fff solid;
        border-radius: 100px;
    }

    .user-content{
        padding-left: 30px;
        text-align: left;
    }

    .user-name{
        color: #333333;
        margin-top:10px;
        font-size: 24px;
    }

    .user-id{
        color: #999999;
        margin-top:20px;
        font-size: 20px;
    }

    .user-school{
        color: #999999;
        margin-top:20px;
        font-size: 20px;
    }
    .table-box{
        margin-top:30px;
    }
    .table-heard{
        background-color: #1796EF ;
        color: #ffffff;
    }


    

    .change-class-box{
        text-align: right;
        padding-right: 14%;
    }
    .top-title{
        text-align: center;
        font-size:24px;
        margin-top:3vh;
    }

    .examination-box{
        margin-top:5vh;
    }

    .work-box{
        padding:30px;
    }


    .work-title{
        font-size:24px;
        padding-bottom:10px;
    }

    .work-start-time{
        margin-top:10px;
    }

    .work-end-time{
        margin-top:10px;
    }

    .work-teacher-name{
        margin-top:10px;
    }

    .work-img-div{
        padding:10px;
    }

    .work-show-btn{
        font-size: 28px;
        color: #409EFF;
        cursor: pointer;
        margin-top: 65px;
    }

    .work-desc{
        font-size:18px;
    }

    @media (max-width: 1400px) {
        .work-desc{
            font-size:14px;
        }
    }

</style>
